import { useEffect, useState } from "react";
import api from "@/utils/api";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { STATUS_STYLES, fmtDate } from "@/components/governance/govUtils";
import { DocumentDialog } from "@/components/governance/DocumentDialog";

const CAT = { agreement: "Agreements", notice: "Notices & lists", policy: "Policies", assurance: "Assurance packs" };

export const GovDocuments = () => {
  const [docs, setDocs] = useState([]);
  const [history, setHistory] = useState(false);
  const [open, setOpen] = useState(null);
  const load = () => api.get(`/governance/documents?include_history=${history}`).then(({ data }) => setDocs(data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [history]);

  return (
    <div className="space-y-4" data-testid="gov-documents">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Every document starts as a draft. Approved and published versions are locked and fingerprinted; changes create a new version.</p>
        <label className="flex items-center gap-2 text-xs whitespace-nowrap"><Checkbox checked={history} onCheckedChange={(v) => setHistory(!!v)} data-testid="gov-docs-history-toggle" /> Show superseded</label>
      </div>
      {Object.entries(CAT).map(([cat, label]) => {
        const rows = docs.filter((d) => d.category === cat);
        if (!rows.length) return null;
        return (
          <div key={cat} className="bg-white border border-border rounded-md overflow-hidden">
            <p className="px-4 py-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground bg-slate-50 border-b">{label}</p>
            <table className="w-full text-sm table-fixed">
              <colgroup><col /><col className="w-20" /><col className="w-28" /><col className="w-28" /><col className="w-36" /></colgroup>
              <tbody>
                {rows.map((d) => (
                  <tr key={d.id} onClick={() => setOpen(d.id)} className="border-b last:border-0 hover:bg-slate-50 cursor-pointer" data-testid={d.status === "superseded" || d.status === "withdrawn" ? `gov-doc-row-${d.doc_type}-${d.id}` : `gov-doc-row-${d.doc_type}`}>
                    <td className="px-4 py-2.5 font-medium">{d.title}</td>
                    <td className="px-4 py-2.5 text-xs text-muted-foreground whitespace-nowrap">v{d.version}</td>
                    <td className="px-4 py-2.5"><Badge variant="outline" className={`text-[10px] ${STATUS_STYLES[d.status]}`}>{d.status.replace("_", " ")}</Badge></td>
                    <td className="px-4 py-2.5 text-xs">{d.legal_review_required && ["draft", "in_review"].includes(d.status) && <span className="text-amber-700">Legal review</span>}</td>
                    <td className="px-4 py-2.5 text-xs text-muted-foreground whitespace-nowrap">Review {fmtDate(d.review_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
      <DocumentDialog docId={open} onClose={() => setOpen(null)} onChanged={load} />
    </div>
  );
};
